import { useContext, useState } from 'react';
import { Dropdown } from '../Dropdown/Dropdown';
import { ImageIcon } from '../icons/ImageIcon';
import { PopperToolbar, PopperWrapper, ToolbarItem } from './TextEditor.styles';
import { ImageUploadPropTypes } from './TextEditor.types';
import { ImageContext } from './ImageContext';
import { UploadImage } from '../UploadImage/UploadImage';

const optionHeight = {
  computer: 335,
  web: 238,
};

export function ImageUpaloadToolbar({
  onChange,
}: ImageUploadPropTypes): JSX.Element {
  const [imageSrc, setImageSrc] = useState(null);
  const [imageDimentions] = useState<{
    height: 'auto' | number;
    width: 'auto' | number;
  }>({ height: 'auto', width: 'auto' });
  const [height, setHeight] = useState(optionHeight.computer);
  const { images, setImages } = useContext(ImageContext);
  const [buttonReference, setButtonReference] = useState<HTMLButtonElement>(
    null,
  );
  const [expanded, setExpanded] = useState(false);
  function handleClose() {
    setExpanded(false);
    setHeight(optionHeight.computer);
    setImageSrc(null);
  }
  function handleAddImage({ url, file }) {
    onChange(url, imageDimentions.height, imageDimentions.width);
    setImageSrc(null);
    handleClose();
    setImages({ ...images, [url]: { file, ref: null } });
  }

  return (
    <Dropdown
      expanded={expanded}
      placement="bottom"
      onClose={handleClose}
      buttonReference={buttonReference}
      matchButtonWidth={false}
      buttonElement={() => (
        <ToolbarItem
          $active={expanded}
          ref={setButtonReference}
          onClick={() => setExpanded(!expanded)}
        >
          <ImageIcon />
        </ToolbarItem>
      )}
      popperElement={() => (
        <PopperWrapper $height={height} $width={300}>
          <PopperToolbar>
            <UploadImage
              value={{ url: imageSrc, file: images?.[imageSrc] }}
              onAdd={handleAddImage}
              onCancel={handleClose}
              id="imageUpload"
              disabled={!expanded}
              label="Select Image"
              resetOnSave
              elevation={5}
            />
          </PopperToolbar>
        </PopperWrapper>
      )}
    />
  );
}
